import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const NatureResponsibleContent = ({ data, boName }) => {

    useEffect(() => {
        const {
            labels,
            values,
            extendedLabels,
            extendedValues
        } = ReportUtils.buildStackedData({
            data: data.boByNatureAndResponsible,
            base: "responsible",
            bars: "reason_name",
            amountValues: "total_bos",
            top: 10,
            hasLimit: true
        });

        GraphicUtils.stackedBarChart("bo-nature-responsible", values, labels, `Total de ${boName}`, "", true);
        ReportUtils.createExportableTable(["Natureza", ...extendedLabels], extendedValues, "Natureza e responsável");
    }, [data]);

    return (
        <div className="chart-report">
            <span className="chart-title">Total de {boName} por natureza e responsável {data.boByNatureAndResponsible?.length >= 10 ? ' (TOP 10)' : ''}</span>
            <div className="mt-3" id="bo-nature-responsible"></div>
            <span className="obs-warn mt-4">* {boName} com mais de uma Natureza serão contabilizados uma vez para cada Natureza.</span>
        </div>
    );
};

export default NatureResponsibleContent;